<template>
  <div>
    <ArticleDetail :hiddenBtn="true" :newsId="this.$route.query.news_id"/>
  </div>
</template>

<script>
// 快诊的h5,每日推荐
import ArticleDetail from './ArticleDetail'

export default {
  name: 'ArticleDetailDiagnose',
  components: {ArticleDetail}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ArticleDetailDiagnose.vue